export default __webpack_public_path__ + "static/media/480_dummy2016-deko01-de-mobile.89cdb030.png";